import animation, { cubicBezierBackgroundColor } from "@constants/animation"
import breakpoints from "@constants/breakpoints"
import colors from "@constants/colors"
import React from "react"
import styled from "styled-components"

const invertedProps = `
  background: none;
  border: solid 1px ${colors.black};

  @media ${breakpoints.laptop} {
    &:hover {
      background: none;
    }
  }
`
export const Button = styled.button<{ inverted?: boolean }>`
  display: flex;
  width: 100%;
  height: 48px;
  align-items: center;
  justify-content: center;
  transition: background-color ${animation.medium} ${cubicBezierBackgroundColor};
  background-color: ${colors.black};
  border: none;
  border-radius: 2px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
  &:active {
    background-color: ${colors.black};
  }

  @media ${breakpoints.laptop} {
    &:hover {
      background-color: ${colors.hoverBlack};
    }
  }

  ${({ inverted }) => (inverted ? invertedProps : "")}
`

export interface TextButtonProps
  extends React.PropsWithoutRef<JSX.IntrinsicElements["button"]> {
  children: React.ReactNode
  inverted?: boolean
  onClick?: () => void
  type?: "button" | "reset" | "submit"
}

const TextButton: React.FC<TextButtonProps> = ({
  children,
  inverted,
  onClick,
  type = "button",
}) => (
  <Button inverted={inverted} onClick={onClick} type={type}>
    {children}
  </Button>
)

export default TextButton
